import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'

import { clx } from '@/utils/clx'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
	React.ElementRef<typeof PopoverPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
		/**
		 * Optional portal container. When the popover is rendered inside a modal dialog/drawer, pass
		 * the dialog element here so the content lands inside the dialog's interactive layer;
		 * otherwise the modal's `pointer-events: none` makes the content unclickable.
		 */
		container?: HTMLElement | null
	}
>(({ className, align = 'center', sideOffset = 4, container, ...props }, ref) => (
	<PopoverPrimitive.Portal container={container ?? undefined}>
		<PopoverPrimitive.Content
			ref={ref}
			align={align}
			sideOffset={sideOffset}
			className={clx(
				'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border border-ui-border-base bg-ui-bg-base p-4 text-ui-fg-base shadow-md outline-none',
				className
			)}
			{...props}
		/>
	</PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
